import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Card} from "components/Card/Card.jsx";
import SimpleReactValidator from 'simple-react-validator';
import {helperFunctions as HF} from 'helper/helperFunctions';
import {objectsConstants as OC} from 'redux/constant/objects-constant';
import $ from 'jquery';
import {withRouter} from 'react-router-dom';
import {FiKey} from 'react-icons/fi';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Tooltip,
    Popover,
} from "react-bootstrap";
import {CSVReader} from 'react-papaparse';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import {brandActions} from '../../../../redux/actions/brand-actions';
import {confirmAlert} from 'react-confirm-alert';
import Confirmalertfordelete from '../../../ThemeComponents/confirmAlertForDelete';
import ExcelReader from '../../ExcelReader/ExcelReader';

let _ = require('lodash');
var cloneDeep = require('lodash.clonedeep');

const DragHandle = SortableHandle(() => <OverlayTrigger placement="bottom"
                                                        overlay={<Popover id="tooltip">Click and Hold to
                                                            Drag</Popover>}><span
    className="moveIcon orderDetailsAction"></span></OverlayTrigger>);
const SortableItem = SortableElement(({
                                          value,
                                          onInputHandler,
                                          deleteConfirmListItem,
                                          onKeyClick,
                                          uniqueAttributes,
                                          keyAdded,
                                          validatorData
                                      }) => (
    <tr test1={`innerItem-${value.key}`} key={`innerItem-${value.key}`}
        style={value.value['db_column'] ? null : {background: 'rgba(255,0,0,0.1)'}}>
        <td>{value.key + 1}</td>
        <td className="text-capitalize">
            <div className="flexElem">
                {
                    value.value['is_key_attribute'] === true ?
                        <OverlayTrigger placement="bottom"
                                        overlay={<Tooltip id="tooltip">At least one key must be selected!</Tooltip>}>
                            <button className="mr-xs yes keyBtn" style={!keyAdded ? {color: '#ed2939'} : null}
                                    onClick={() => {
                                        onKeyClick(true, value.key, 'is_key_attribute')
                                    }}>
                                <FiKey/>
                            </button>
                        </OverlayTrigger>
                        :
                        <OverlayTrigger placement="bottom"
                                        overlay={<Tooltip id="tooltip">At least one key must be selected!</Tooltip>}>
                            <button className="mr-xs no keyBtn" style={!keyAdded ? {color: '#ed2939'} : null}
                                    onClick={() => {
                                        onKeyClick(false, value.key, 'is_key_attribute')
                                    }}>
                                <FiKey/>
                            </button>
                        </OverlayTrigger>
                }
                {
                    value.value['title']
                }

            </div>
        </td>
        <td style={{wordWrap: "break-word", wordBreak: "break-all", width: "10%"}}>
            {value.value['sample_value']}
        </td>
        <td>


            <select onChange={(e) => onInputHandler(e, value.key)} className="form-control" name='data_type'
                    value={value.value['data_type']}>
                {
                    OC.dataTypeList.map((row, index) => (
                        <option value={row.value} key={index}> {row.label} </option>
                    ))
                }
            </select>
            {
                value.value['data_type'] === 'datetime' &&
                <select onChange={(e) => onInputHandler(e, value.key)} className="form-control mt-xs" name='date_format'
                        value={value.value['date_format']}>
                    <option value="" selected hidden>Select Format</option>
                    {
                        OC.DATE_FORMATS.map((row, index) => (
                            <option value={row.value} key={index}> {row.label} </option>
                        ))
                    }
                </select>
            }
        </td>
        <td>
            <DragHandle/>
            <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Delete Row</Popover>}>
                <span>
                    <button onClick={() => {
                        deleteConfirmListItem(value.key)
                    }} className="deleteIcon orderDetailsAction">&nbsp;</button>
                </span>
            </OverlayTrigger>
            {
                !value.value['db_column'] ?
                    <OverlayTrigger placement="bottom"
                                    overlay={<Popover id="tooltip"><b>Invalid Title!</b>Please delete this row or
                                        re-upload file.</Popover>}>
                        <i className="fa fa-exclamation-circle fa-lg" style={{color: 'red'}}></i>
                    </OverlayTrigger>
                    : null
            }
        </td>
    </tr>
));

const SortableList = SortableContainer(({
                                            lookupAttributes,
                                            onInputHandler,
                                            deleteConfirmListItem,
                                            onKeyClick,
                                            uniqueAttributes,
                                            keyAdded,
                                            validatorData
                                        }) => {
    return (
        <tbody>
        {
            lookupAttributes.map((value, index) => (
                <SortableItem key={`item-${index}`} index={index} value={{value: value, key: index}}
                              test={`item-${index}`} onInputHandler={onInputHandler}
                              deleteConfirmListItem={deleteConfirmListItem} onKeyClick={onKeyClick}
                              uniqueAttributes={uniqueAttributes} keyAdded={keyAdded} validatorData={validatorData}/>
            ))
        }
        </tbody>
    );
});
const csvRef = React.createRef()

class LookupCSV extends Component {
    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
        this.validatorData = new SimpleReactValidator();
        this.state = {
            brand: {
                brand_id: ''
            },
            lookup_attributes: this.props.location.state ? this.props.location.state.original.attributes : [],
            fileType: '',
            data_definition: {
                start_position: '',
                end_position: '',
            },
            file_uploaded: false,
            previous_page: false,
            isChanged: false,
            quantity_length: [],
            export_length: [],
            sample_file_type: {},
            table_name: this.props.location.state ? this.props.location.state.original.table_name : '',
            key: this.props.location.state ? true : false,
            keyAdded: this.props.location.state ? true : true,
            unmounting: true,
        }
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState(({lookup_attributes}) => ({
            lookup_attributes: arrayMove(lookup_attributes, oldIndex, newIndex),
        }));
    };
    handleReadCSV = (data) => {
        try {
            this.setState({
                ...this.state,
                sample_file_type: csvRef.current.inputFileRef.current.files[0],
                isChanged: true,
            })
            if (data.length > 0) {
                let lookup_attributes = [];
                let keys = Object.keys(data[0].data);
                for (let i = 0; i < keys.length; i++) {
                    lookup_attributes.push(
                        {
                            title: keys[i].trim() || '',
                            db_column: keys[i].replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase() || '',
                            sample_value: data[0].data[keys[i]],
                            import_order: Number(i) + 1,
                            data_type: HF.checkClosestDatatype(data[0].data[keys[i]]).value,
                            is_key_attribute: false,
                            date_format: null,
                        }
                    )
                }
                this.setState(prevState => ({
                        lookup_attributes: lookup_attributes,
                    })
                )
            }
            setTimeout(() => {
                this.setSticky();
            }, 100);
        } catch (e) {
            this.warningMsg("The selected file is not a valid csv or txt file!");
        }
    }
    handleOnError = (err, file, inputElem, reason) => {
        console.log(err);
    }
    handleImportOffer = (e) => {
        this.fileInput.current.value = '';
        this.fileInput.current.click();
    }
    onInputHandler = (e, rowIndex) => {
        const atts = cloneDeep(this.state.lookup_attributes);
        if (e.target.type === 'text' || e.target.type === 'select-one') {
            const {name, value} = e.target;
            if (name === 'title') {
                atts[rowIndex]['db_column'] = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase();
            }
            atts[rowIndex][name] = value;
        } else if (e.target.type === 'checkbox') {
            const {name, checked} = e.target;
            atts[rowIndex][name] = checked;
        }
        this.setState({lookup_attributes: atts});
    }
    onKeyClick = (data, rowIndex, name) => {
        const atts = cloneDeep(this.state.lookup_attributes);
        atts[rowIndex][name] = !data;
        this.setState({lookup_attributes: atts});
    }

    deleteConfirmListItem = (id) => {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="row" description={"Are you sure to delete this row"}
                                           onClosePro={onClose} deleteType={() => this.onDeleteAttribute(id)}/>
                )
            }
        })
    }
    onDeleteAttribute = (key) => {
        const newAtts = this.state.lookup_attributes.filter((data, index) => {
            return index !== key
        })
        this.setState({
            lookup_attributes: newAtts
        })
    }

    setFileType(event) {
        const {value} = event.target;
        this.setState({
            ...this.state,
            fileType: value
        })
    }

    setResourceFile = (key, value) => {
        console.log('object', this.state.sample_file_type)
        this.setState({
            sample_file_type: value
        });
    }
    warningMsg = (text = "") => {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="row" msgType='warning' description={text} onClosePro={onClose}/>
                )
            }
        })
    }

    onAttributesSubmit = () => {
        if (this.validatorData.allValid()) {
            // if (this.state.keyAdded && this.state.key) {
            let obj;
            let count = 0;
            let columns = 0;
            let end = 0;
            const newArray = this.state.lookup_attributes.filter(data => {
                if (data.db_column) {
                    columns += 1;
                }
                if (!data.is_key_attribute) {
                    end += 1;
                }
                delete data.created_at;
                delete data.updated_at;
                return data;
            })
            if (end === this.state.lookup_attributes.length) {
                this.setState({
                    ...this.state,
                    keyAdded: false,
                    key: true
                })
                this.warningMsg("Please select at least one key");
                return;
            }
            let action = 'create';
            if (this.props.location.state) {
                action = 'update';
            }
            obj = {
                lookup_attributes: JSON.stringify(newArray),
                table_name: this.state.table_name,
                sample_file: this.state.sample_file_type,
                action: action,
            }
            if (!(obj.sample_file instanceof File)) {
                delete obj.sample_file
            }
            const formData = new FormData();
            for (const key in obj) {
                formData.append(key, obj[key]);
            }
            if (columns === this.state.lookup_attributes.length) {
                this.props.storeBrandLookupTableCall(formData, this.props.match.params.brandId).then(res => {
                    this.setState({
                        file_uploaded: true,
                        isChanged: false,
                    })
                    if (res.status === 'success')
                        this.props.history.push(`/Admin/brand/${this.props.match.params.brandId}/lookup-listing`)
                })
            }
            console.log('remove the key condition')
            // }
        } else {
            this.setState({submitted: false});
            this.validatorData.showMessages();
            this.forceUpdate();
        }

        let that = this;
        if ($(".theme_table").hasClass("stickyHeader")) {
            that.setSticky();
        }
    }
    simpleInputHandler = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value.replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase()
        })
    }
    uploadFileAgain = () => {
        this.setState({
            brand: {
                brand_id: ''
            },
            lookup_attributes: [],
            fileType: '',
            data_definition: {
                start_position: '',
                end_position: '',
            },
            sample_file_type: {},
        })
    }

    handleExcelAttributes = (data, file_type) => {
        if (data.length > 0) {
            this.setState({
                lookup_attributes: data,
                sample_file_type: file_type,
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if (!_.isEqual(this.state.lookup_attributes, prevState.lookup_attributes) && this.state.key) {
            let end = 0;
            this.state.lookup_attributes.forEach((item, index) => {
                if (!item.is_key_attribute) {
                    end += 1;
                }
            })
            if (end === this.state.lookup_attributes.length) {
                this.setState({
                    keyAdded: false
                })
            } else {
                this.setState({
                    keyAdded: true
                })
            }
        }
        if (!_.isEqual(this.state.lookup_attributes, prevState.lookup_attributes) && (this.state.lookup_attributes.length > 0 && this.state.isChanged === false)) {
            this.setState({
                isChanged: true,
            })
        }
    }

    setSticky = () => {
        if ($(".theme_table").hasClass("stickyHeader")) {
            $(".stickyTarget").width($(".stickyHeader").outerWidth());
            let rowCount = 0;
            $(".stickyHeader th").each(function () {
                $(".stickyTarget th:eq(" + rowCount + ")").width($(this).width());
                rowCount++;
            });

            $(".sidebar").hasClass("showSideNav") ?
                $(".stickyTarget").css("left", ($(".stickyHeader").offset().left - 45))
                :
                $(".stickyTarget").css("left", "50px")
        }
    }

    componentDidMount() {
        let that = this;
        if (this.props.location.state) {
            setTimeout(function () {
                if (that.props.location.state.original.attributes.length > 0) {
                    that.setSticky();
                }
            }, 500)
        }
    }

    render() {
        const {lookup_attributes} = this.state;
        const that = this;
        if (($(".theme_table").hasClass("stickyHeader")) && that.state.unmounting) {
            $(window).resize(function () {
                if ($(".theme_table").hasClass("stickyHeader")) {
                    that.setSticky();
                }
            });

            $(window).scroll(function () {
                if ($(".theme_table").hasClass("stickyHeader")) {
                    if ($(this).scrollTop() >= $(".stickyHeader").offset().top) {
                        $(".stickyTarget").fadeIn("fast");
                    } else {
                        $(".stickyTarget").fadeOut("fast");
                    }
                }
            });
        }
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                className="mt-lg"
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    {
                                                        lookup_attributes.length === 0 &&
                                                        <h3 style={{textAlign: 'center', fontWeight: "500"}}>Lookup
                                                            Table Data Definition</h3>
                                                    }

                                                    {
                                                        lookup_attributes.length > 0 &&
                                                        <h3 style={{textAlign: 'center', fontWeight: "500"}}>Manage
                                                            Attributes</h3>
                                                    }
                                                </Col>

                                                <div className="col-md-8 col-md-offset-2">
                                                    {
                                                        lookup_attributes.length === 0 &&
                                                        <div className="mt-lg text_16">
                                                            Define brand lookup data by uploading a sample CSV or EXCEL
                                                            file. A few rules to follow.
                                                            <ol className="blackNumber">
                                                                <li>The first row shall contain data/column header</li>
                                                                <li>Do not leave empty column header</li>
                                                                <li>Do not leave empty rows between data rows</li>
                                                            </ol>
                                                            <hr className="medium"/>

                                                        </div>
                                                    }
                                                    <div>
                                                        {
                                                            lookup_attributes.length === 0 &&
                                                            <React.Fragment>
                                                                <div className="text_18 mt-xlg"><strong>Select File
                                                                    Format: </strong></div>

                                                                <div onChange={this.setFileType.bind(this)}>
                                                                    {
                                                                        OC.LOOKUP_DEFINITION_FORMATS.map((data, index) => {
                                                                            return (
                                                                                <div key={index} className="mt-sm">
                                                                                    <label
                                                                                        className="container-radio">
                                                                                        <input type="radio"
                                                                                               value={data.key}
                                                                                               name="fileType"/>
                                                                                        <span
                                                                                            className="checkmark"></span>
                                                                                        {data.label}
                                                                                    </label>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </React.Fragment>
                                                        }
                                                    </div>
                                                </div>


                                                <div className="clearfix"></div>
                                                {
                                                    lookup_attributes.length > 0 &&
                                                    <div id="brandDataTable table-responsive col-md-12">
                                                        <div className="mt-lg text_16">Data read from Sample File</div>
                                                        <table
                                                            className="table stickyHeader theme_table blank table-striped mt-md">
                                                            <thead>
                                                            <tr>
                                                                <th>Order</th>
                                                                <th>Title</th>
                                                                <th>Sample Value</th>
                                                                <th>Data Type</th>
                                                                <th>Control</th>
                                                            </tr>
                                                            </thead>
                                                            <SortableList axis='xy' lookupAttributes={lookup_attributes}
                                                                          onSortEnd={this.onSortEnd}
                                                                          onInputHandler={this.onInputHandler}
                                                                          deleteConfirmListItem={this.deleteConfirmListItem}
                                                                          onKeyClick={this.onKeyClick}
                                                                          uniqueAttributes={this.state.unique_values}
                                                                          keyAdded={this.state.keyAdded}
                                                                          validatorData={this.validatorData}
                                                                          useDragHandle/>
                                                        </table>
                                                    </div>
                                                }

                                                {/*<CSVReader*/}
                                                {/*    onFileLoaded={this.handleReadCSV}*/}
                                                {/*    inputRef={this.fileInput}*/}
                                                {/*    style={{ display: 'none' }}*/}
                                                {/*    onError={this.handleOnError}*/}
                                                {/*    ref="csvReader"*/}
                                                {/*    configOptions={{*/}
                                                {/*        skipEmptyLines: true,*/}
                                                {/*        delimiter: this.state.delimiter*/}
                                                {/*    }}*/}
                                                {/*    //*/}
                                                {/*/>*/}
                                                <div className="flexElem respFlex">
                                                    {
                                                        this.state.lookup_attributes.length > 0 &&
                                                        <div className="col-md-4">
                                                            <label htmlFor="table_name">Table Name:</label>
                                                            <input type="text" className="form-control"
                                                                   name="table_name" onChange={this.simpleInputHandler}
                                                                   value={this.state.table_name}
                                                                   disabled={this.props.location.state ? true : false}/>
                                                            {this.validatorData.message('Table Name', this.state.table_name, 'required|min:3')}
                                                        </div>
                                                    }

                                                    <div
                                                        className={this.state.lookup_attributes.length > 0 ? "col-md-8" : "col-md-12"}>
                                                        <div className="flexElem mt-sm justifyCenter respFlex">
                                                            {/* <button className="customBtn m-md btnBlack" type='button' onClick={() => { this.props.history.goBack() }} >Go Back</button> */}
                                                            {
                                                                this.state.fileType === 'CSV' && this.state.lookup_attributes.length === 0 &&
                                                                <div className="customDrop m-sm"><CSVReader
                                                                    onDrop={this.handleReadCSV}
                                                                    onError={this.handleOnError}
                                                                    addRemoveButton
                                                                    removeButtonColor='#659cef'
                                                                    onRemoveFile={this.handleOnRemoveFile}
                                                                    ref={csvRef}
                                                                    accept={'text/csv, .csv, application/vnd.ms-excel, .txt'}
                                                                    style={{display: 'none'}}
                                                                    config={{
                                                                        skipEmptyLines: true,
                                                                        delimiter: this.state.delimiter,
                                                                        header: true
                                                                    }}
                                                                >
                                                                    <button className="customBtn btnBlue">Upload CSV
                                                                        File
                                                                    </button>
                                                                </CSVReader></div>
                                                            }
                                                            {
                                                                this.state.fileType === 'EXCEL' && this.state.lookup_attributes.length === 0 &&
                                                                <div className="m-sm">
                                                                    <ExcelReader
                                                                        type='LOOKUP'
                                                                        returnExcelAtts={this.handleExcelAttributes}
                                                                    />
                                                                </div>
                                                            }
                                                            {
                                                                this.state.lookup_attributes.length > 0 &&
                                                                <div className="m-sm">
                                                                    <button onClick={this.uploadFileAgain}
                                                                            className="customBtn btnRed">Discard And
                                                                        Re-upload File
                                                                    </button>
                                                                </div>
                                                            }
                                                            {
                                                                this.state.lookup_attributes.length > 0 &&
                                                                <div className="m-sm">
                                                                    <button className="customBtn btnBlue"
                                                                            onClick={this.onAttributesSubmit}
                                                                            disabled={this.state.isChanged ? false : true}>Save
                                                                        Updates
                                                                    </button>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>

                {
                    this.state.lookup_attributes.length > 0 &&
                    <table className="table theme_table stickyTarget blank table-striped mt-md">
                        <thead>
                        <tr>
                            <th>Order</th>
                            <th>Title</th>
                            <th>Sample Value</th>
                            <th>Data Type</th>
                            <th>Control</th>
                        </tr>
                        </thead>
                    </table>
                }
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        storeBrandLookupTableCall: (data, id) => {
            return dispatch(brandActions.storeBrandLookupTable(data, id))
        },
    });
};

function mapStateToProps(state, ownProps) {
    const {brand} = state.brandReducer;
    return {
        brand,
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LookupCSV));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/Lookup Definition/LookupCSV.jsx